import React from 'react'

const identity = () => {}

export default class Region extends React.PureComponent {
  static defaultProps = {
    onEscape: identity,
    onFocusOut: identity,
    onClickOutside: identity
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, true)
    document.addEventListener('focusin', this.handleFocus)
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, true)
    document.removeEventListener('focusin', this.handleFocus)
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  contains(e) {
    let ref = this.currentRef()

    if (!ref) {
      return
    }

    return ref.contains(e.target)
  }

  render() {
    let { innerRef, onClickOutside, onFocusOut, onEscape, ...props } =
      this.props

    return (
      <div
        ref={innerRef}
        {...props}
      />
    )
  }

  currentRef() {
    return this.props.innerRef && this.props.innerRef.current
  }

  handleClick = e => {
    if (!this.contains(e)) {
      this.props.onClickOutside(e)
    }
  }

  handleFocus = e => {
    if (!this.contains(e)) {
      this.props.onFocusOut(e)
    }
  }

  handleKeyDown = e => {
    if (e.key === 'Escape') {
      this.props.onEscape(e)
    }
  }
}
